class Accordion {
  constructor(container, options = {}) {
    this.container = container;
    this.headers = container.querySelectorAll(
      options.headerSelector || ".accordion-header"
    );

    this.openFirst = options.openFirst ?? true;

    if (!this.headers.length) return;

    this.init();
  }

  init() {
    // Reset all items
    this.headers.forEach((header) => {
      const body = header.nextElementSibling;

      header.classList.remove("active");

      if (body) {
        body.style.maxHeight = null;
      }
    });

    // Open first item
    if (this.openFirst && this.headers[0]) {
      this.openItem(this.headers[0]);
    }

    // Single event listener (better performance)
    this.container.addEventListener("click", (event) => {
      const header = event.target.closest(".accordion-item-header");

      // Ignore outside clicks
      if (!header || !this.container.contains(header)) return;

      this.toggleItem(header);
    });
  }

  toggleItem(header) {
    const isActive = header.classList.contains("active");

    if (isActive) {
      this.closeItem(header);
    } else {
      this.openItem(header);
    }
  }

  openItem(header) {
    const body = header.nextElementSibling;

    if (!body) return;

    header.classList.add("active");

    // requestAnimationFrame improves rendering performance
    requestAnimationFrame(() => {
      body.style.maxHeight = body.scrollHeight + "px";
    });
  }

  closeItem(header) {
    const body = header.nextElementSibling;

    if (!body) return;

    header.classList.remove("active");
    body.style.maxHeight = null;
  }
}

// Init accordions after DOM load
document.addEventListener("DOMContentLoaded", () => {
  const accordions = document.querySelectorAll(".accordion");

  if (!accordions.length) return;

  accordions.forEach((accordion) => {
    new Accordion(accordion, {
      headerSelector: ".accordion-item-header",
      openFirst: true,
    });
  });
});